"canon".datatype({source: "WC", readOnly: true, exportable: true})
"path".field({key: true})
"blueprint".field()
